export default __webpack_public_path__ + "static/World-map-8dd80d7b8525f7765bc26cc6f7ada44e.svg";